import { useState } from 'react'
import './StatusDropdown.css'

const NOMINATION_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
]

const SERVICE_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'cancelled', label: 'Cancelled' },
]

function StatusDropdown({ currentStatus, onStatusChange, disabled, type }) {
  const [updating, setUpdating] = useState(false)

  const handleChange = async (e) => {
    const newStatus = e.target.value
    if (newStatus === currentStatus) return

    setUpdating(true)
    try {
      await onStatusChange(newStatus)
    } catch (error) {
      console.error('Failed to update status:', error)
    } finally {
      setUpdating(false)
    }
  }

  return (
    <select
      className="status-dropdown"
      value={currentStatus}
      onChange={handleChange}
      disabled={disabled || updating || (type === 'service' && (currentStatus === 'rejected' || currentStatus === 'cancelled')) || (type === 'nomination' && (currentStatus === 'completed' || currentStatus === 'cancelled'))}
    >
      {(type === 'service' ? SERVICE_STATUS_OPTIONS : NOMINATION_STATUS_OPTIONS).map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default StatusDropdown
